









































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { IdentityFullInfo } from '../types';
import { useIdentityAvatarUrl } from '../hooks';
import { AvatarIcon } from '@tt4b/ttam-enums';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-identity-custom-list-item';

export default defineComponent({
  name,
  props: {
    source: {
      type: Object as PropType<IdentityFullInfo>,
      default: () => ({}),
    },
    onClick: {
      type: Function as PropType<(i: IdentityFullInfo) => void>,
      default: () => () => undefined,
    },
    onPopoverCTA: {
      type: Function as PropType<(i: IdentityFullInfo) => void>,
      default: () => () => undefined,
    },
    onEditIdentity: {
      type: Function as PropType<(i: IdentityFullInfo) => void>,
      default: () => () => undefined,
    },
    onDeleteIdentity: {
      type: Function as PropType<(i: IdentityFullInfo) => void>,
      default: () => () => undefined,
    },
    activeId: {
      type: String,
      default: '',
    },
    isSupportEditAndDelete: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const onClickItem = () => {
      if (!props.source.disabled) {
        props.onClick(props.source);
      }
    };
    const sourceAvatar = computed(() => useIdentityAvatarUrl(props.source?.avatarIcon as AvatarIcon));
    const onPopoverCTAItem = () => {
      props.onPopoverCTA(props.source);
    };
    const handleEditIdentity = () => {
      props.onEditIdentity(props.source);
      trackEvent('edit_custom_identity');
    };
    const handleDeleteIdentity = () => {
      props.onDeleteIdentity(props.source);
      trackEvent('delete_custom_identity');
    };
    return {
      name,
      sourceAvatar,
      onClickItem,
      onPopoverCTAItem,
      handleEditIdentity,
      handleDeleteIdentity,
    };
  },
});
